module.exports = __webpack_public_path__ + "static/media/fruit-cherry-2.6af2f339.png";